import routePaths from 'src/contstant/routePaths';

/**
 * Routes where the Astra launcher and panel are hidden.
 *
 * These are focused, full-page flows (e.g. profile preferences) where the
 * floating assistant would overlap the primary task. The AstraProvider stays
 * mounted regardless, so any in-progress conversation is preserved and restored
 * when the user navigates back to a route where Astra is shown.
 *
 * To hide Astra on another page, add its route path here — no other change is
 * needed.
 */
export const ASTRA_HIDDEN_ROUTES: ReadonlySet<string> = new Set<string>([
  routePaths.PROFILE_PREFERENCES.path,
]);

/**
 * Whether the Astra launcher/panel should be hidden for the given route.
 *
 * @param pathname the current location pathname (e.g. from `useLocation()`)
 * @returns true if Astra should be suppressed on this route
 */
export function isAstraHiddenOnRoute(pathname: string): boolean {
  return ASTRA_HIDDEN_ROUTES.has(pathname);
}
